import ClaimTypeView from 'text!../views/pa-claim-type.html';
import CollisionLossDetailsView from 'text!../views/pa-collision-loss-details.html';
import CollisionVehiclesView from 'text!../views/pa-collision-vehicles.html';
import TheftDetailsView from 'text!../views/pa-theft-details.html';
import GlassDetailsView from 'text!../views/pa-glass-details.html';
import RepairChoiceView from 'text!../views/pa-repair-choice.html';
import NewRepairFacilityView from 'text!../views/pa-new-repair-facility.html';
import PreferredRepairFacilityView from 'text!../views/pa-preferred-repair-facility.html';
import PABaseFnolWizardCtrl from 'edge/fnol/pa/controllers/PABaseFnolWizardCtrl';
import ClaimTypeCtrl from 'edge/fnol/pa/controllers/PAClaimTypeCtrl';
import CollisionDetailsCtrl from 'edge/fnol/pa/controllers/PACollisionDetailsCtrl';
import CollisionVehiclesCtrl from 'edge/fnol/pa/controllers/PACollisionVehiclesCtrl';
import GlassOrTheftDetailsCtrl from 'edge/fnol/pa/controllers/PAGlassOrTheftDetailsCtrl';
import RepairChoiceCtrl from 'edge/fnol/pa/controllers/PARepairChoiceCtrl';
import NewRepairFacilityCtrl from 'edge/fnol/pa/controllers/PANewRepairFacilityCtrl';
import PreferredRepairFacilityCtrl from 'edge/fnol/pa/controllers/PAPreferredRepairFacilityCtrl';
import loadGoogleMapsAPI from 'gw-portals-google-maps-js';

export default function () {
    const paBaseFnolWizard = {
        name: 'paBaseFnolWizard',
        parent: 'baseFnolWizard',
        abstract: true,
        controller: PABaseFnolWizardCtrl,
        template: '<div ui-view></div>',
        data: {
            trackingUrl: ''
        }
    };

    loadGoogleMapsAPI();

    return {
        paBaseFnolWizard: paBaseFnolWizard,
        paClaimType: {
            name: 'paClaimType',
            parent: paBaseFnolWizard,
            template: ClaimTypeView,
            controller: ClaimTypeCtrl
        },
        paCollisionLossDetails: {
            name: 'paCollisionLossDetails',
            parent: paBaseFnolWizard,
            template: CollisionLossDetailsView,
            controller: CollisionDetailsCtrl
        },
        paCollisionVehicles: {
            name: 'paCollisionVehicles',
            parent: paBaseFnolWizard,
            template: CollisionVehiclesView,
            controller: CollisionVehiclesCtrl
        },
        paTheftDetails: {
            name: 'paTheftDetails',
            parent: paBaseFnolWizard,
            template: TheftDetailsView,
            controller: GlassOrTheftDetailsCtrl
        },
        paGlassDetails: {
            name: 'paGlassDetails',
            parent: paBaseFnolWizard,
            template: GlassDetailsView,
            controller: GlassOrTheftDetailsCtrl
        },
        paServiceChoice: {
            name: 'paServiceChoice',
            parent: paBaseFnolWizard,
            template: RepairChoiceView,
            controller: RepairChoiceCtrl
        },
        paNewRepairFacility: {
            name: 'paNewRepairFacility',
            parent: paBaseFnolWizard,
            template: NewRepairFacilityView,
            controller: NewRepairFacilityCtrl
        },
        paPreferredRepairFacility: {
            name: 'paPreferredRepairFacility',
            parent: paBaseFnolWizard,
            template: PreferredRepairFacilityView,
            controller: PreferredRepairFacilityCtrl
        }
    };
}
